import { SalesOrderStatus } from '@synergy/models';
import { useEffect, useState } from 'react';

import { useThunkDispatch } from '../../store/use-thunk-dispatch';

/** Sent when an approval was decided, so the counter in the rail follows. */
export const APPROVALS_CHANGED = 'palo:order-approvals-changed';

/** How many orders wait for approval, for the counter beside the rail entry (#2281). */
export const usePendingApprovalCount = (): number => {
    const dispatch = useThunkDispatch();
    const [count, setCount] = useState(0);

    useEffect(() => {
        const load = (): void => {
            void dispatch(async (_dispatch, _getState, { api }) => {
                const result = await api.orderApprovals.cget(
                    new URLSearchParams({ statuses: SalesOrderStatus.CartPending, limit: '1' })
                );
                setCount(result.success ? result.result.total : 0);
            });
        };

        load();
        window.addEventListener(APPROVALS_CHANGED, load);

        return () => window.removeEventListener(APPROVALS_CHANGED, load);
    }, [dispatch]);

    return count;
};
